export const FETCH_DISTRIBUTORPROFILE_INIT_ACTION =
  "FETCH_DISTRIBUTORPROFILE_INIT_ACTION";
export const FETCH_DISTRIBUTORPROFILE_SUCCESS_ACTION =
  FETCH_DISTRIBUTORPROFILE_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRIBUTORPROFILE_FAIL_ACTION =
  FETCH_DISTRIBUTORPROFILE_INIT_ACTION + "_ERROR";

export const FETCH_DISTRIBUTORPROF_INIT_ACTION =
  "FETCH_DISTRIBUTORPROF_INIT_ACTION";
export const FETCH_DISTRIBUTORPROF_SUCCESS_ACTION =
  FETCH_DISTRIBUTORPROF_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRIBUTORPROF_FAIL_ACTION =
  FETCH_DISTRIBUTORPROF_INIT_ACTION + "_ERROR";

export const EDIT_DISTRIBUTORPROF_INIT_ACTION =
  "EDIT_DISTRIBUTORPROF_INIT_ACTION";
export const EDIT_DISTRIBUTORPROF_SUCCESS_ACTION =
  EDIT_DISTRIBUTORPROF_INIT_ACTION + "_SUCCESS";
export const EDIT_DISTRIBUTORPROF_FAIL_ACTION =
  EDIT_DISTRIBUTORPROF_INIT_ACTION + "_ERROR";

export const FETCH_STATES_INIT_ACTION = "FETCH_STATES_INIT_ACTION";
export const FETCH_STATES_SUCCESS_ACTION =
  FETCH_STATES_INIT_ACTION + "_SUCCESS";
export const FETCH_STATES_FAIL_ACTION = FETCH_STATES_INIT_ACTION + "_ERROR";

export const FETCH_DISTRICTBYID_INIT_ACTION = "FETCH_DISTRICTBYID_INIT_ACTION";
export const FETCH_DISTRICTBYID_SUCCESS_ACTION =
  FETCH_DISTRICTBYID_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRICTBYID_FAIL_ACTION =
  FETCH_DISTRICTBYID_INIT_ACTION + "_ERROR";

export const FETCH_BANK_INIT_ACTION = "FETCH_BANK_INIT_ACTION";
export const FETCH_BANK_SUCCESS_ACTION = FETCH_BANK_INIT_ACTION + "_SUCCESS";
export const FETCH_BANK_FAIL_ACTION = FETCH_BANK_INIT_ACTION + "_ERROR";

export function fetchDistributorProfile(value) {
  return {
    type: FETCH_DISTRIBUTORPROFILE_INIT_ACTION,
    value: value
  };
}

export function Distributorprof() {
  // console.log("Distributorprof**********************");
  return {
    type: FETCH_DISTRIBUTORPROF_INIT_ACTION
  };
}
export function EditDistributorprof(value) {
  // console.log("EditDistributorprof**********************");
  return {
    type: EDIT_DISTRIBUTORPROF_INIT_ACTION,
    value: value
  };
}
export function fetchStates() {
  return {
    type: FETCH_STATES_INIT_ACTION
  };
}

export function fetchBank() {
  // console.log("fetchBank**********************");
  return {
    type: FETCH_BANK_INIT_ACTION
  };
}
export function fetchDistrictById(value) {
  return {
    type: FETCH_DISTRICTBYID_INIT_ACTION,
    value: value
  };
}
